Drupal.behaviors.takeover = {
	attach: function () {
		const bodyEl = document.querySelector("body");
		const takeover = document.querySelector("#takeover");
		const takeoverBtn = document.querySelectorAll(".takeover__button");
		const languageBtn = document.querySelector(".language-link");

		if (takeover && window.localStorage) {
			const hasVisited = localStorage.getItem("takeoverVisited");

			if (!hasVisited) {
				bodyEl.classList.add("takeover-open");
				takeover.classList.add("show");
			}

			takeoverBtn.forEach((btn) => {
				btn.addEventListener("click", function () {
					bodyEl.classList.remove("takeover-open");
					takeover.classList.remove("show");
					localStorage.setItem("takeoverVisited", "true");
				});
			});

			languageBtn.addEventListener("click", function () {
				localStorage.setItem("takeoverVisited", "false");
			});
		}
	}
};